export const GET_ORGAN_REPORT_SUCCESS = "GET_ORGAN_REPORT_SUCCESS";
export const GET_ORGAN_REPORT_ERROR = "GET_ORGAN_REPORT_ERROR";
export const GET_BIOMARKER_SUCCESS = "GET_BIOMARKER_SUCCESS";
export const GET_BIOMARKER_ERROR = "GET_BIOMARKER_ERROR";
export const GET_BIOMARKER_REPORT_SUCCESS = "GET_BIOMARKER_REPORT_SUCCESS";
export const GET_BIOMARKER_REPORT_ERROR = "GET_BIOMARKER_REPORT_ERROR";
export const ORGAN_REQUEST = "ORGAN_REQUEST";
export const PAGE_CHANGE = "PAGE_CHANGE";
